import React, { useEffect, useRef, useState } from "react";
import { useSubheader } from "@metronic/layout";
import {
  Alert,
  Col,
  Row,
  Accordion,
} from "react-bootstrap";
import * as Yup from "yup";
import { setIn } from "formik";
import { InssuredData } from "@components/panels/insured-data/inssured-data";
import { HospitalData } from "@components/panels/hospital-data/hospital-data";
import { FamilyData } from "@components/panels/family-data/family-data";
import { Documentation } from "@components/panels/documentation/documentation";
import { MedicalFees } from "@components/panels/medical-fee/medical-fees";
import { Binnacle } from "@components/panels/binnacle/binnacle";
import { getBySlug, update } from "@services/hospitalization";
import { getLasMcMovementtByCase } from "@services/mc-movements";
import { updateCaseDetails } from "@services/case-details";
import { MedicAssignationTrakingMedic } from "@components/panels/medic-assignation-tracking/medic-assignation-tracking-medic";
import { IfHasRole } from "@metronic/_helpers";
import { getMexicoTimestamp } from "@utils/date-utils";
import swal from "sweetalert";
import { isEmpty } from "@utils/check-object-empty";
import { CASE_STATUS } from "@constants/case-statuses";
import { MedicDataTreating } from "@components/panels/medic-treating-data/medic-data-treating";
import { InsuranceData } from "@components/panels/insurance-data/insurance-data";
import { Opinion } from "@components/panels/dictum/dictum";
import AuthLetters from "@components/panels/auth-letter/auth-letters";
import { useHistory } from "react-router";
import { Button, Form } from "react-bootstrap";
import CaseHeader from "@components/panels/case-header/case-header";
import BlockCaseContext from "@contexts/block-case-context";
import { useCommentValidation } from "@contexts/comment-validation-context";
import WithCommentValidation from "@components/shared/with-comment-validation";
import $ from "jquery";
import { useAutomaticCommentSave } from "@hooks/use-automatic-comment-save";

const AlwaysWithYouDetails = (props) => {
  const [caseRecord, setCaseRecord] = useState({});
  const [totalLetters, setTotalLetters] = useState(0.0);
  const [errors, setErrors] = useState({});
  const [hasError, setHasError] = useState(false);
  const [shouldBlockCase, setShouldBlockCase] = useState(true);
  const [mcMovement, setMcMovement] = useState({});
  const [finalizationReason, setFinalizationReason] = useState("");

  const submitFormMedicAssignation = useRef(null);
  const submitFormMedicAssignationErrors = useRef(null);

  const subheader = useSubheader();
  const { validateCommentRequired } = useCommentValidation();
  const { saveCommentAutomatically } = useAutomaticCommentSave({ caseData: caseRecord });
  const { saveCommentAutomaticallyUnam } = useAutomaticCommentSave({
    caseData: caseRecord,
    eventStage: null,
    comment: "FAVOR DE FACTURAR A UNAM, DE NO HACERLO NO SE PODRÁ PAGAR",
    isPageable: false,
    hideReason: true,
  });

  const { slug } = props.match.params;

  let history = useHistory();

  const onClickFinalize = async () => {
    if (finalizationReason.trim() === "") {
      alert("Debe capturar el motivo de finalización");
      return;
    }

    if (!validateCommentRequired()) {
      return;
    }

    if (submitFormMedicAssignation.current !== null) {
      await submitFormMedicAssignation.current();
      if (!isEmpty(submitFormMedicAssignationErrors.current)) {
        return;
      }
    }

    // El motivo queda en el detalle del caso; el movimiento de asignacion lo guarda aparte.
    await updateCaseDetails(caseRecord.id, { finalizationReason: finalizationReason.trim() }).catch(() => {});

    update(
      { caseStatusId: CASE_STATUS.FINISHED, fecfinalizada: getMexicoTimestamp() },
      caseRecord.id
    ).then(() => {
      swal("Guardado Exitoso", "Caso Finalizado", "success");
      history.push("/24_7_contigo");
    });
  };

  const handleSave = async function() {
    let dataForms = {};

    for (let pair of new FormData(
      document.getElementById("formu2")
    ).entries()) {
      dataForms[pair[0]] = pair[1];
    }

    for (let pair of new FormData(
      document.getElementById("formu3")
    ).entries()) {
      dataForms[pair[0]] = pair[1];
    }

    const validationSchema = Yup.object().shape({
      assuredFlastname: Yup.string().required(
        "El campo apellido paterno asegurado es requerido"
      ),
      assuredMlastname: Yup.string().required(
        "El campo apellido materno asegurado es requerido"
      ),
      assuredName: Yup.string().required(
        "El campo nombre asegurado es requerido"
      ),
      assuredEmail: Yup.string()
        .required("El campo email asegurado es requerido")
        .email("El campo email asegurado parece no ser un valido"),
      incomeDatetime: Yup.string().required(
        "El campo fecha de ingreso es requerido"
      ),
      hospitalIden: Yup.string().required(
        "El campo folio hospital es requerido"
      ),
      diagnosis: Yup.string().required(
        "El campo DIAGNÓSTICO presuntivo es requerido"
      ),
      familiarEmail: Yup.string().email(
        "El campo email familiar no parece ser un email"
      ),
    });

    try {
      await validationSchema.validate(dataForms, { abortEarly: false });

      dataForms = { ...caseRecord, ...dataForms };

      //dataForms["caseStatusId"] = 2;
      if (!validateCommentRequired()) {
        return;
      }
      await saveCommentAutomatically();
      await saveCommentAutomaticallyUnam();
      dataForms['caseStatusId'] = null;
      update(dataForms, caseRecord.id).then((response) => {
        setErrors({});
        setHasError(false);
        history.push("/24_7_contigo");
      });
    } catch (err) {
      const errorsCatch = err.inner.reduce((formError, innerError) => {
        return setIn(formError, innerError.path, innerError.message);
      }, {});
      setErrors(errorsCatch);
      setHasError(true);
    }
  };

  useEffect(() => {
    getBySlug(slug).then((response) => {
      setCaseRecord(response.data);
      getLasMcMovementtByCase(response.data.id).then((currentMcMovement) =>
        setMcMovement(currentMcMovement.data)
      );
    });

    subheader.setTitle("24/7 Contigo");
  }, [slug]);

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        24/7 Contigo
      </Alert>

      <CaseHeader caseRecord={caseRecord} requiresTabulationSlot={<></>} />

      <Alert show={hasError} variant="danger" style={{ fontSize: "14px" }}>
        {Object.entries(errors).map((error, idx) => (
          <p key={idx}>{error[1]}</p>
        ))}
      </Alert>

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
        <Accordion className="mt-5">
          <HospitalData
            icon="fa-search"
            eventKey="0"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <InssuredData
            icon="fa-search"
            icone="fa-pencil-alt"
            eventKey="2"
            data={caseRecord}
            disabledAll={false}
            bindSubmitForm={() => {}}
          />
          <FamilyData
            icon="fa-search"
            icone="fa-pencil-alt"
            eventKey="3"
            data={caseRecord}
            disabledAll={false}
            bindSubmitForm={() => {}}
            required={false}
          />
          <MedicDataTreating
            icon="fa-search"
            eventKey="4"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <InsuranceData
            icon="fa-search"
            eventKey="6"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          {(IfHasRole("Admin") || IfHasRole("ADMINAXA") || IfHasRole("ADMIN_REGION_CELULA") || IfHasRole("DICTAMEN-CONTLCOSTOS")) && (
            <MedicAssignationTrakingMedic
              icon="fa-pencil-alt"
              eventKey="11"
              data={caseRecord}
              mcMovement={mcMovement}
              finalizationReason={finalizationReason.trim()}
              bindSubmitForm={(submitForm) => (submitFormMedicAssignation.current = submitForm)}
              bindErrors={(errors) => (submitFormMedicAssignationErrors.current = errors)}
            />
          )}
          <Opinion
            icon="fa-search"
            eventKey="7"
            data={caseRecord}
            disabledAll={true}
            totalLetters={totalLetters}
            bindSubmitForm={() => {}}
          />
          <MedicalFees
            icon="fa-search"
            icone="fa-pencil-alt"
            eventKey="10"
            data={caseRecord}
            hideBtnInsurance={false}
            hideFormCreate={true}
            showForm={true}
            {...props}
          />
          <AuthLetters
            icon="fa-search"
            showForm={false}
            hideDeleteOption={true}
            eventKey="8"
            data={caseRecord}
            disabledAll={false}
            setTotalLetters={setTotalLetters}
            {...props}
          />
          <Documentation
            icon="fa-search"
            icone="fa-pencil-alt"
            eventKey="9"
            data={caseRecord}
            disabledAll={false}
            {...props}
          />
        </Accordion>
        <Accordion defaultActiveKey="10" className="mt-5">
          <Binnacle
            icon="fa-pencil-alt"
            eventKey="10"
            data={caseRecord}
            disabledAll={false}
            hideButton={false}
            eventStage="24/7 Contigo"
            {...props} />
        </Accordion>
      </BlockCaseContext.Provider>

      <Row>
        <Col md={6}>
          <Form.Group className="mt-5">
            <Form.Label>Motivo de finalización (para Finalizar Caso) *</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              maxLength={500}
              value={finalizationReason}
              onChange={(event) => setFinalizationReason(event.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button className="mt-2" variant="success" onClick={handleSave}>
            Guardar
          </Button>
        </Col>
        <Col className="text-right">
          <Button className="mt-2" variant="danger" onClick={onClickFinalize}>
            Finalizar Caso
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default WithCommentValidation(AlwaysWithYouDetails);

